import RsaGestioneCentroDiurno from "../";

const routes = [{ name: "RsaGestioneCentroDiurnoListPage", path: "/rsagestionecentrodiurno", component: RsaGestioneCentroDiurno.RsaGestioneCentroDiurnoListPage, meta: { title: " Gestione Presenze" } }];
export default routes;
